import HolographicCard from '@/components/base/HolographicCard';

export default function PrecursorSection() {
  return (
    <section id="precursor" className="relative py-32">
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-5xl md:text-6xl font-bold mb-6 font-orbitron">
              <span
                className="text-white"
                style={{
                  textShadow: `
                    -1px -1px 0 #8b5cf6,
                    1px -1px 0 #8b5cf6,
                    -1px 1px 0 #8b5cf6,
                    1px 1px 0 #8b5cf6,
                    -2px -2px 0 #06b6d4,
                    2px -2px 0 #06b6d4,
                    -2px 2px 0 #06b6d4,
                    2px 2px 0 #06b6d4
                  `
                }}
              >
                Precursor
              </span>
            </h2>
            <p className="text-2xl text-white/90 font-medium mb-4">
              Deterministic Market Intelligence
            </p>
          </div>

          <HolographicCard className="p-8 md:p-12">
            <div className="mb-12">
              <p className="text-white/80 text-lg leading-relaxed max-w-5xl mx-auto">
                Precursor is a deterministic intelligence engine capable of forecasting directional market tone without reliance on traditional data inputs like price, news, technical indicators, or sentiment analysis. Instead, Precursor compiles structured temporal field geometry through a governed execution environment to generate repeatable, forward-only market forecasts.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8 mb-12">
              <div className="text-center space-y-4">
                <div className="w-16 h-16 bg-gradient-to-br from-cyan-400/20 to-cyan-600/20 rounded-lg flex items-center justify-center border border-cyan-400/30 mx-auto">
                  <i className="ri-refresh-line text-cyan-400 text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-white font-bold text-xl mb-2">Deterministic</h4>
                  <p className="text-white/70 text-sm">Same inputs. Same outputs. Every time.</p>
                </div>
              </div>
              
              <div className="text-center space-y-4">
                <div className="w-16 h-16 bg-gradient-to-br from-purple-400/20 to-purple-600/20 rounded-lg flex items-center justify-center border border-purple-400/30 mx-auto">
                  <i className="ri-shield-check-line text-purple-400 text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-white font-bold text-xl mb-2">Auditable</h4>
                  <p className="text-white/70 text-sm">Every forecast is traceable, repeatable, and symbolically locked.</p>
                </div>
              </div>

              <div className="text-center space-y-4">
                <div className="w-16 h-16 bg-gradient-to-br from-cyan-400/20 to-purple-400/20 rounded-lg flex items-center justify-center border border-cyan-400/30 mx-auto">
                  <i className="ri-trophy-line text-cyan-400 text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-white font-bold text-xl mb-2">Proven</h4>
                  <p className="text-white/70 text-sm">Validated through historical benchmarking and blind forward testing with public cryptographic proof.</p>
                </div>
              </div>
            </div>

            <div className="text-center">
              <p className="text-white/70 text-base leading-relaxed max-w-4xl mx-auto">
                Precursor is powered by the same governed execution architecture that runs GenesisOS.
              </p>
            </div>
          </HolographicCard>
        </div>
      </div>

      {/* Background elements */}
      <div className="absolute top-20 right-20 w-40 h-40 bg-gradient-to-br from-cyan-400/5 to-transparent rounded-full blur-2xl"></div>
      <div className="absolute bottom-20 left-20 w-32 h-32 bg-gradient-to-br from-purple-400/5 to-transparent rounded-full blur-2xl"></div>
    </section>
  );
}
